import { Messages } from '../../codegen/Localize';
import { FlowOutputStepRunStatus } from '../../ts/models/FlowOutputStepRunInfo';
import { RunFlowTaskStatus } from '../../ts/models/RunFlowTaskInfo';


export function localizeFlowRunHistoryStatus(status: string): string {
  switch (status) {
    case FlowOutputStepRunStatus.pending:
      return Messages.flowRunStatusPending();
    case FlowOutputStepRunStatus.inProgress:
      return Messages.flowRunStatusInProgress();
    case FlowOutputStepRunStatus.success:
      return Messages.flowRunStatusSucceeded();
    case FlowOutputStepRunStatus.failed:
      return Messages.flowRunStatusFailed();
    case FlowOutputStepRunStatus.cancelled:
      return Messages.flowRunStatusCancelled();
    default:
      return Messages.flowRunStatusFailed();
  }
}

export function localizeRunFlowTaskStatus(status: string): string {
  switch (status) {
    case RunFlowTaskStatus.Suspended:
      return Messages.suspended();
    case RunFlowTaskStatus.InProgress:
      return Messages.flowRunStatusInProgress();
    case RunFlowTaskStatus.Succeeded:
      return Messages.flowRunStatusSucceeded();
    case RunFlowTaskStatus.Failed:
      return Messages.flowRunStatusFailed();
    case RunFlowTaskStatus.Scheduled:
    default:
      return Messages.runFlowTaskStatusScheduled();
  }
}
